import type { GroupedWorkspaceConfigModel } from '@r/api/generated/client.schemas.ts';

/** Checks whether purchase proofs are explicitly enabled for the current workspace. */
export function isPurchaseProofFeatureEnabled(
  workspaceConfig?: GroupedWorkspaceConfigModel
): boolean {
  return workspaceConfig?.groupedConfigs?.core?.['enable-purchase-proof'] === 'true';
}
